import settings from 'config';
import {
  ConsentPageRequest,
  ConsentPageResponse,
  PostConsentRequest,
  PostConsentResponse,
  UserLimitReachedOrExceededError,
} from 'types/consent';
import api from './api';

/**
 * @returns all data needed to display consent page
 */
const getConsentPageData = async ({
  consentChallenge,
}: ConsentPageRequest): Promise<ConsentPageResponse> => {
  const data = await api.get<any>(
    `${settings.externalDeveloperPortalServiceBaseUrl}/v2/idp/consent/${consentChallenge}`,
  );

  return {
    title: data.title,
    body: data.body,
    logo: data.logo,
    privacyPolicyText: data.privacy_policy_text,
    privacyPolicyUrl: data.privacy_policy_url,
    consentItems: data.consent_items,
  };
};

/**
 * Logs consent answer and returns generated redirect
 */
const postConsent = async ({
  consentChallenge,
  accepted,
}: PostConsentRequest): Promise<PostConsentResponse> => {
  try {
    const data = await api.post<string>(
      `${settings.authApiBaseUrl}/idp/consent?consent_challenge=${consentChallenge}`,
      { accepted },
    );
    return { redirectUri: data };
  } catch (e: any) {
    if (
      e.message.includes('consent failed, this app has reached its user limit')
    ) {
      throw new UserLimitReachedOrExceededError();
    } else {
      throw e;
    }
  }
};

export default { getConsentPageData, postConsent };
